export const ACCORDION_KEYS = {
  KEY_FEATURES: 'key-features',
  DELIVERY: 'delivery',
  SPARE_PARTS: 'spare-parts',
  PREMIUM_GUARANTEE: 'premium-guarantee',
  DOWNLOADS: 'downloads',
  ACCESSORIES: 'accessories',
} as const;

export type AccordionKey = ValueOf<typeof ACCORDION_KEYS>;
